import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_FILTER_360, GET_FILTER_360_SUCCESS, GET_FILTER_360_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getFilter360({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];
    const { filterType } = payload.urlParams;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/${filterType}-filters`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_FILTER_360_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_FILTER_360_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_FILTER_360_ERROR, payload: error });
  }
}

export function* watchGetFilter360() {
  yield takeEvery(GET_FILTER_360, getFilter360);
}

function* getFilter360Saga() {
  yield all([fork(watchGetFilter360)]);
}

export default getFilter360Saga;
